const initialState = {
  myUniverse: [],
  myUniverse_allocation_sumError: false,
  overRideAllocation: false,
  UploadedUniverse : {}
};

export default function iqciolive(
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  const { payload, type } = action;

  let newState = Object.assign({}, state);
  var iqlive = newState;

  switch (type) {
    case "SET_IQCIO_LIVE_MY_UNIVERSE":
      iqlive.myUniverse = [...payload];
      break;

    case "SET_IQCIO_LIVE_MY_UNIVERSE_UPLOADED":
      iqlive.UploadedUniverse =[...payload];
      break;

    case "SET_IQCIO_LIVE_ALLOCATION_SUM_ERROR":
      iqlive.myUniverse_allocation_sumError = payload;
      break;

    case "SET_IQCIO_LIVE_MYUNIVERSE_VALUE":
      iqlive.myUniverse[payload.i][payload.key] = payload.value;
      break;

    case "SET_IQCIO_LIVE_TOGGLE":
      iqlive.overRideAllocation = payload;
      break;

    case "ADD_IQCIO_LIVE_MYUNIVERSE_obj":
      let addSymbols = iqlive.myUniverse;

      let obj = action.payload;
      function addSymbol(addSymbol, obj) {
        let fundName = obj["fund_name"];
        let found = addSymbols.some((el) => el["fund_name"] === fundName);

        if (found) {
          addSymbols.map((Ob) =>
            Ob["fund_name"] == fundName ? (Ob["val"] = obj["val"]) : Ob
          );
        } else {
          addSymbol.push(obj);
        }
      }
      addSymbol(addSymbols, obj);
      // addSymbols.push(action.payload);
      iqlive.myUniverse = [...addSymbols];

      break;

    case "REMOVE_MY_UNIVERSE_DATA":
      let removeSymbols = iqlive.myUniverse;

      for (let i in action.payload) {
        const ix = action.payload[i];
        removeSymbols.splice(ix, 1);
      }

      iqlive.myUniverse = [...removeSymbols];

      break;
    default:
      return state;
  }

  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/iqciolive.reducer.js